// extracted by mini-css-extract-plugin
module.exports = {"title":"SearchPanelResults_title__r80kz","results":"SearchPanelResults_results__ySGaM","section":"SearchPanelResults_section__XHrfO"};